module.exports = __webpack_public_path__ + "static/media/gift.3624b450.svg";